import { CloseIcon } from "@chakra-ui/icons"
import {
  Box,
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftAddon,
  InputLeftElement,
  Text,
} from "@chakra-ui/react"
import { useState } from "react"

export function AlertTranspCode({ isOpen, onClose, saveCotations }) {
  const [code, setCode] = useState("")
  const [loading, setLoading] = useState(false)

  async function onSubmit() {
    if (code === "") {
      return
    }

    setLoading(true)
    await saveCotations({
      transpCode: code,
    })
    setLoading(false)
    onClose()
  }

  return (
    <Flex
      display={isOpen ? "flex" : "none"}
      position="fixed"
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      zIndex={999}
    >
      <Box
        color="white"
        w="600px"
        h="200px"
        p={3}
        bg="#e9e9e9"
        transition="all 0.2s"
        fontFamily={"Roboto, sans-serif"}
        display="flex"
        justifyContent="center"
        alignItems="center"
        //leve box-shadow
        boxShadow="0px 0px 1px 0px rgba(0,0,0,0.75)"
        borderRadius="5px"
        flexDirection="column"
      >
        <CloseIcon
          position={"absolute"}
          right={"10px"}
          top={"10px"}
          cursor={"pointer"}
          color={"#95c620"}
          onClick={onClose}
        />
        <Flex gap={2}>
          <InputGroup maxW="300px">
            <InputLeftAddon children="Código" bgColor="#95c620" />
            <Input
              type="text"
              placeholder="Código da transportadora"
              color="gray.700"
              borderColor="#95c620"
              onChange={(e) => setCode(e.target.value)}
              maxLength={8}
            />
          </InputGroup>
          <Button
            bgColor="#95c620"
            _hover={{ bgColor: "#95c620" }}
            onClick={onSubmit}
            isDisabled={code === ""}
            isLoading={loading}
            loadingText="Verificando..."
          >
            Confirmar
          </Button>
        </Flex>
      </Box>
    </Flex>
  )
}
